import script from "./WidgetModule.vue?vue&type=script&setup=true&lang=js"
export * from "./WidgetModule.vue?vue&type=script&setup=true&lang=js"

import "./WidgetModule.vue?vue&type=style&index=0&id=2fb55c7e&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2fb55c7e"]])

export default __exports__